export default {"src":"/login-app/[GIT_HASH]/_next/static/media/panel_show_top.6a02b511.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};